import React, { useState, useEffect, useRef } from "react";

import { useDispatch, useSelector, shallowEqual } from "react-redux";
import ImageChecker from "../../Generic/ImageChecker";

import {
  Table,
  Tooltip,
  Tag,
  Form,
  Input,
  Button,
  Space,
  Modal,
  Descriptions,
  Statistic,
  Col,
  Popconfirm,
  Collapse,
  Select,
  DatePicker,
  InputNumber,
  TimePicker,
  Checkbox,
  message,
} from "antd";
import {
  MenuUnfoldOutlined,
  MenuFoldOutlined,
  UserOutlined,
  VideoCameraOutlined,
  UploadOutlined,
  DeploymentUnitOutlined,
  SearchOutlined,
  EditOutlined,
  PlusOutlined,
} from "@ant-design/icons";

import "./styles.scss";

import moment from "moment";
import {
  getData,
  editItem,
  addItem,
  deleteItem,
  searchData,
} from "../../../Redux/actions/crudActions";
import { errorParser, numberWithCommas } from "../../../utils/helpers";
import {
  getInBranchItems,
  setMonthlyInventory,
  updateMonthlyInventory,
} from "../../../Redux/actions/monthlyInventoryActions";

import { getProduct } from "../../../Redux/actions/productActions";
import {
  setProductInventory,
  setProductInventoryWithLocation,
} from "../../../Redux/actions/inventoryActions";
import {
  getWeightedExchangeRate,
  calculateWeightedExchangeRate,
} from "../../../Redux/actions/exchangerateActions";

import ProductBranchLogTable from "../../analytics/ProductBranchLogTable";

const { RangePicker } = DatePicker;
const { Panel } = Collapse;
const { Option } = Select;

const Index = ({ thisItem, thisAudit, onModalClose }) => {
  const dispatch = useDispatch();
  const { branchitems, user } = useSelector(
    (state) => ({
      branchitems: state.monthlyInventory.branchitems,
      user: state.auth.user,
    }),
    shallowEqual
  );

  const [isModalVisible, setIsModalVisible] = useState(false);

  const [loading, setLoading] = useState(false);
  const [categorized, setCategorized] = useState([]);
  const [itemcount, setItemcount] = useState(null);
  const [itemcount2, setItemcount2] = useState(null);

  const [itemcountChanged, setItemcountChanged] = useState(false);
  const [itemcount2Changed, setItemcount2Changed] = useState(false);

  const [currentWeighted, setCurrentWeighted] = useState(0);

  const [createDate, setCreatedDate] = useState(moment());

  useEffect(() => {
    getcurrentrate();
  }, []);

  const getcurrentrate = async () => {
    var currentaverage = await dispatch(getWeightedExchangeRate());
    if (currentaverage) {
      setCurrentWeighted(currentaverage.value.toFixed(2));
    }
  };

  useEffect(() => {
    if (isModalVisible) {
      console.log(thisItem, thisAudit);
      if (thisItem.requested_status == "pending") {
        if (thisItem.requested_main_unit_input) {
          setItemcount(thisItem.requested_main_unit_input);
        }
        if (thisItem.requested_second_unit_input) {
          setItemcount2(thisItem.requested_second_unit_input);
        }
      }
    }
  }, [isModalVisible]);

  const renderItemTable = (currentgroup, it1, it2) => {
    const columns = [
      {
        title: "Image",

        render: (text, record, index) => {
          return (
            <ImageChecker
              url={`${process.env.REACT_APP_AWS_S3}${record.id}.png`}
              success={
                <img
                  src={`${process.env.REACT_APP_AWS_S3}${record.id}.png`}
                  alt="image"
                  className={"prodimage"}
                />
              }
              fail={
                <img
                  src={`${process.env.REACT_APP_AWS_S3}logo192.png`}
                  alt="image"
                  className={"prodimage"}
                />
              }
            />
          );
        },
      },
      {
        title: "Name",
        dataIndex: "name",
        key: "name",
        width: "100rem",
        sorter: {
          compare: (a, b) => a.name - b.name,
        },

        search: "name",
        render: (text, record, index) => {
          return <div className="smoltxt">{text}</div>;
        },
      },
      {
        title: "count",

        render: (text, record, index) => {
          console.log(record);
          return (
            <div className="vertical-flex">
              <Input
                type={"number"}
                value={itemcount}
                placeholder=" "
                className={"inputwidth"}
                min={0}
                width={"100%"}
                defaultValue={null}
                step={1}
                onChange={(e) => {
                  setItemcount(e.target.value);
                  setItemcountChanged(true);
                }}
                addonAfter={<span className="tinytxt">{record.unit} </span>}
              />

              {record.second_unit_rate &&
              record.second_unit &&
              parseFloat(record.second_unit_rate) > 0 &&
              parseFloat(record.second_unit_rate) !== 1 ? (
                <Input
                  type={"number"}
                  placeholder=" "
                  className={"inputwidth"}
                  min={0}
                  width={"100%"}
                  defaultValue={null}
                  step={1}
                  onChange={(e) => {
                    setItemcount2(e.target.value);
                    setItemcount2Changed(true);
                  }}
                  addonAfter={
                    <span className="tinytxt">{record.second_unit} </span>
                  }
                />
              ) : null}
            </div>
          );
        },
      },
    ];

    return (
      <Table
        columns={columns}
        dataSource={[thisItem]}
        pagination={false}
        showHeader={false}
      />
    );
  };

  const createAuditItemRequest = async () => {
    if (!loading) {
      setLoading(true);
      message.info("submitting audit request");

      var audit_items = thisAudit.audited_items;

      var new_audit_items = audit_items.map((item) => {
        var newitem = {
          ...item,
        };
        if (item.id == thisItem.id) {
          var itemsum = 0;

          if (itemcount && itemcountChanged) {
            itemsum = itemsum + parseFloat(itemcount);
            newitem["requested_main_unit_input"] = parseFloat(itemcount);
          }
          if (itemcount2 && itemcount2Changed) {
            itemsum =
              itemsum +
              parseFloat(itemcount2) * parseFloat(item.second_unit_rate);
            newitem["requested_second_unit_input"] = parseFloat(itemcount2);
          }
          newitem["requested_status"] = "pending";
          newitem["requested_count"] = itemsum;
          newitem["requested_at"] = moment().format("YYYY-MM-DD HH:mm:ss");
          newitem["requested_by"] = user.id;
          newitem["requested_name"] = user.name;
        }

        return newitem;
      });

      var new_audit = {
        ...thisAudit,
        audited_items: new_audit_items,
      };
      console.log(new_audit);
      var newsold = await dispatch(updateMonthlyInventory(new_audit));

      setLoading(false);
      closeModal("reset");
    }
  };

  const changeThisAudit = async () => {
    if (!loading) {
      setLoading(true);
      message.info("recording audit change");

      var audit_items = thisAudit.audited_items;
      var itemsum = 0;
      var new_audit_items = audit_items.map((item) => {
        var newitem = {
          ...item,
        };
        if (item.id == thisItem.id) {
          if (itemcount) {
            itemsum = itemsum + parseFloat(itemcount);
            newitem["main_unit_input_new"] = parseFloat(itemcount);
          }
          if (itemcount2) {
            itemsum =
              itemsum +
              parseFloat(itemcount2) * parseFloat(item.second_unit_rate);
            newitem["second_unit_input_new"] = parseFloat(itemcount2);
          }
          newitem["requested_status"] = "completed";
          newitem["new_count"] = itemsum;
          newitem["updated_at"] = moment().format("YYYY-MM-DD HH:mm:ss");
          newitem["updated_by"] = user.id;
          newitem["updated_name"] = user.name;
        }

        return newitem;
      });

      var new_audit = {
        ...thisAudit,
        audited_items: new_audit_items,
      };

      var newsold = await dispatch(updateMonthlyInventory(new_audit));
      var product3 = await dispatch(
        setProductInventoryWithLocation(
          thisItem.id,
          thisItem.name,
          itemsum,
          "change",
          "audit changed",
          thisAudit.branch,
          thisAudit.branch_name
        )
      );

      setLoading(false);
      closeModal("reset");
    }
  };

  const footer = () => {
    return (
      <div className="addsalesfooter">
        <div>
          {/* <DatePicker
            defaultValue={createDate}
            value={createDate}
            disabledDate={disabledDate}
            onChange={(e)=>{setCreatedDate(e)}}
          /> */}
        </div>
        <div>
          <Popconfirm
            title="Are you sure this is correct?"
            onConfirm={() => {
              if (itemcount !== null || itemcount2 !== null) {
                if (user.role == "admin" || user.role == "manager") {
                  changeThisAudit();
                } else {
                  createAuditItemRequest();
                }
              } else {
                message.warning("please input value");
              }
            }}
            okText="Yes"
            cancelText="No"
          >
            <Button type="primary" loading={loading}>
              {user.role == "admin" || user.role == "manager"
                ? "Change Count"
                : `Submit Request`}
            </Button>
          </Popconfirm>
        </div>
      </div>
    );
  };

  const closeModal = (action) => {
    if (!loading) {
      setItemcount(null);
      setItemcount2(null);
      setIsModalVisible(false);
      onModalClose(action);
    }
  };

  return (
    <>
      <div className={""}>
        <Button
          type="text"
          icon={<EditOutlined />}
          onClick={() => {
            setIsModalVisible(true);
            setLoading(false);
          }}
        ></Button>
      </div>

      {isModalVisible ? (
        <Modal
          title={
            user.role == "admin" || user.role == "manager"
              ? "Change Audit Item Count"
              : `Request Change Audit Item Count`
          }
          visible={isModalVisible}
          className={"minwidthis50 nopadding"}
          footer={footer()}
          onCancel={() => {
            closeModal();
          }}
          bodyStyle={{ padding: "0px" }}
        >
          <div className="audit-content">
            {user.role == "admin" || user.role == "manager" ? (
              <div className="logpart ">
                <h3>Inventory Log</h3>
                <ProductBranchLogTable
                  branchID={thisAudit.branch}
                  productID={thisItem.id}
                  product={thisItem}
                />
              </div>
            ) : null}
            <h5 className="requestchangepart">{`Audit was made on: ${moment(
              thisAudit.created_at
            ).format("LL hh:mm:ss a")}`}</h5>

            {thisItem.requested_count &&
            thisItem.requested_status == "pending" ? (
              <span className="requestchangepart">{`request change from ${numberWithCommas(
                parseFloat(thisItem.new_count).toFixed(3)
              )} ${thisItem.unit} to ${numberWithCommas(
                parseFloat(thisItem.requested_count).toFixed(3)
              )} ${thisItem.unit} at ${moment(thisItem.requested_at).format(
                "LL hh:mm:ss a"
              )}`}</span>
            ) : null}
            {renderItemTable()}
          </div>
        </Modal>
      ) : null}
    </>
  );
};

export default Index;
